var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAdminPremissionEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FAAD14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2495 11.75H29.7495C30.1644 11.75 30.4995 12.0852 30.4995 12.5V27.5C30.4995 27.9148 30.1644 28.25 29.7495 28.25H10.2495C9.83467 28.25 9.49951 27.9148 9.49951 27.5V12.5C9.49951 12.0852 9.83467 11.75 10.2495 11.75ZM11.187 14.3469V26.5625H28.812V14.3469L29.4589 13.843L28.5378 12.6594L27.5347 13.4398H12.462L11.4589 12.6594L10.5378 13.843L11.187 14.3469ZM12.462 13.4375L19.9995 19.2969L27.537 13.4375L28.5401 12.657L29.4612 13.8406L28.8144 14.3445L20.8081 20.5695C20.5779 20.7484 20.2946 20.8455 20.003 20.8455C19.7115 20.8455 19.4282 20.7484 19.1979 20.5695L11.187 14.3469L10.5401 13.843L11.4612 12.6594L12.462 13.4375Z",
    fill: "#FAAD14"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdminPremissionEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AdminPremissionEmail.6f18b33e.svg";
export { ForwardRef as ReactComponent };